// @flow
import type { Epic } from '../../annotations';
import type { GetSessionId } from '../../domain/browserSession';

import * as r from 'ramda';
import { select } from 'redux-most';
import * as signals from '../signals';
import * as messages from '../../domain/messages';
import * as mostc from '../../crosscutting/mostc';

const sessionEpic = (
  getSessionId: GetSessionId,
): Epic => r.pipe(
  select(signals.SEED),
  mostc.map(() => {
    const id = getSessionId();
    return messages.browserSessionLoaded(id);
  }),
);

export default sessionEpic;
